module.exports = __webpack_public_path__ + "img/uniliver(2) 1.9b63ce8.png";